import { useDispatch } from 'react-redux';
import { fetchDataSet, deleteDataset, updateDataset } from 'js/actions';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

export default function useNexsetsAdapter() {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  async function requestNexset(nexsetId) {
    const response = await dispatch(fetchDataSet(nexsetId));
    return response.entities.dataSets[response.result];
  }
  async function deleteNexset(nexsetId) {
    return await dispatch(deleteDataset(nexsetId));
  }
  async function updateNexset(nexsetId, payload) {
    const response = await dispatch(updateDataset(nexsetId, payload));
    return response.entities.dataSets[response.result];
  }

  return {
    requestNexset,
    updateNexset,
    deleteNexset,
  };
}
